export default {
  dbh_login_image_title: 'Present the massive {br} global game {br} market to you',

  dbh_login: 'Login',
  dbh_login_goback_tologin: 'GO Back to Login',
  dbh_login_continue: 'Continue',

  // index
  dbh_login_OA: 'OA',
  dbh_login_account: 'DataBrain Account',
  dbh_login_email: 'Email',
  dbh_login_email_placeholder: 'Please Enter The Email',
  dbh_login_other_methods: 'OR',
  dbh_login_email_desc: `The Overseas URL is for the users who don't have OA accounts or not in China mainland. Only DataBrain accounts can be used to login Overseas URL. Tencent OA users please try this link:`,
  dbh_login_contact_ivyyfchen: 'For DataBrain permission applications, please contact',


  // 账号登陆
  dbh_login_account_login: 'DataBrain Account Login',
  dbh_login_account_name: 'Account Name',
  dbh_login_account_name_placeholder: 'Please Enter The Account Name',
  dbh_login_email_login: 'DataBrain Email Login',
  dbh_login_password: 'Password',
  dbh_login_password_placeholder: 'Please Enter The Password',
  dbh_login_email_password_placeholder: 'Password must be 4-14 characters long.',
  dbh_login_register: 'Register',
  dbh_login_forget_password: 'Forget the Password',
  dbh_login_is_forget_password: 'Change / Forget the Password?',
  dbh_login_forget_password_desc: 'Please contact {name} to get your new account info.',
  dbh_login_ikonw: 'I Konw',

  // 忘记密码
  dbh_login_password_reset_link: 'Password Reset Link has been sent',
  dbh_login_password_reset_link_desc: `We've emailed you instructions. Please go to your inbox and click the link inside to reset your password.`,
  dbh_login_didnot_receive_email: `Didn't receive an email from databrain`,
  dbh_login_resend_confirm: 'Resend Confirmation',
  dbh_login_forget_emailpassowrd_desc: `Forgot your Email password? Enter your email address below, and we'll email you access code for setting a new one`,
  dbh_login_send_code: 'Send Code',
  dbh_login_send_new_code: 'Send New Code',
  dbh_login_verify: 'Verify',
  dbh_login_code_send_success: 'The new code was sent successfully!',
  dbh_login_please_enter_emailed: 'Please enter the access code emailed to you at:',
  dbh_login_code_expires_after: 'Code Expires After',
  dbh_login_enter_access_code: 'Enter Access Code',
  dbh_login_signup_for_free: 'Sign up for free',
  dbh_login_please_enter_occupation: 'Please select your occupation',
  dbh_login_please_enter_unentered_position: 'No Occupation Selected',
  dbh_login_occupation: 'Occupation',
  dbh_login_others: 'Others',
  dbh_login_no_data: 'No data yet',
  dbh_login_word_email: 'Work Email',
  dbh_login_word_email_placeholder: 'Please enter the work email',
  dbh_login_password_confirm: 'Password confirmation',
  dbh_login_password_confirm_placeholder: 'Please enter the password again',
  dbh_login_reason_forapp: 'Reason for application',
  dbh_login_reason_forapp_placeholder: 'Please describe the reason for applying.',

  // 注册成功
  dbh_login_thankyou_register: 'Thank you for registering for DataBrain !',
  dbh_login_click_email_link_desc: 'We will sent you a confirmation email later. Please go to your inbox and click the link inside to enter the DataBrain.',
  dbh_login_register_contant_desc: 'If you have any question, please contact ivyyfchen@tencent.com.',
  dbh_login_register_fail_oa_part1: 'OA users please return to the ',
  dbh_login_register_fail_oa_part2: 'Login Page',
  dbh_login_register_fail_oa_part3: '  and select OA login',

  // 重置密码
  dbh_login_reset_passwords: 'Reset Passwords',
  dbh_login_reset_email_success: 'Reset your Email account Password successfully!',


  // 错误提示
  dbh_login_no_account_enter: 'No Account Name Entered',
  dbh_login_account_format_gsv: `Please use a combination of letters, numbers, and underscores ( _ ). Special characters like ', ", --, /* */ are not allowed.`,
  dbh_login_format_gsv: `Special characters like ', ", --, /* */ are not allowed.`,
  dbh_login_no_password_enter: 'No Password Entered',
  dbh_login_incorrect_username: 'Incorrect Username',
  dbh_login_incorrect_password: 'Incorrect Password',
  dbh_login_no_email_entered: 'No Email Entered',
  dbh_login_no_work_email_entered: 'No Work Email Entered',
  dbh_login_incorrect_email: 'Incorrect Email',
  dbh_login_no_reason_enter: 'No reason entered',
  dbh_login_more_reason_enter: 'Exceeding 500 characters',
  dbh_login_different_passwords: 'Inconsistent Passwords',
  dbh_login_password_format: 'The Password Contains {min} to {max} Characters',
  dbh_login_email_format_error: 'Email format Error',
  dbh_login_incorrenct_code_try_again: 'Sorry,incorrect code,please try again.',
  dbh_login_no_access_code: 'No Access Code Entered',
  dbh_login_no_access_code_format_error: 'Access Code format Error',// TODO,
  dbh_login_error_no_message: ' ',
  dbh_login_error_username: 'Incorrect Account Name Or Password. Please Try Again.',
  dbh_login_error_email: 'Incorrect Email Or Password. Please Try Again.',


  // 错误弹框提示
  dbh_login_oa_login_failed: 'The system did not detect Tencent OA. Please log in using your account credentials or SSO.',
  dbh_login_email_password_timeout: 'Email password is reset incorrectly or times out, please try again.',
  dbh_login_email_sent_5times_err: 'Email access code can only be sent 5 times every 1 hour, please try again later.',
  dbh_login_user_not_or_password_wrong: 'User does not exist or password is wrong.',
  dbh_login_login_errors_5_times: 'The number of login errors is 5 times every 30 minutes, please try again later.',
  dbh_login_account_or_email_not: 'The account name or email does not exist.',
  dbh_login_network_error: 'Network error, please check the network',
  dbh_login_email_exist: 'User email is exist',
  dbh_login_5times_err: 'The number of login errors is 5 times every 30 minutes, please try again later.',

  dbh_login_organization: 'Organization',
  dbh_login_select_organization: 'Please select organization',
  dbh_login_register_format_err: 'This email suffix is not found in allowlist; please contact DataBrain associates',

  dbh_14_days_login: 'Remember me for 14 days',
  dbh_login_type_google: 'Sign in with Google',
  dbh_login_type_google_tip: 'Please use your company email to log in to Google',
  dbh_login_type_sso: 'Sign in with {type}',
  dbh_login_google_email_fail: 'Sorry, the user does not exist.',
  dbh_login_google_email_fail_tip: 'Please use your company email address to sign in to google, if you have any question, please contact',
  dbh_login_get_google_msg_fail: 'Failed to obtain user information from {provider}',
  dbh_login_get_google_msg_fail_tip: 'Please go back and try again, if you have any question, please contact',
  dbh_login_database_query_fail: 'Database Query Failure',
  dbh_login_database_query_fail_tip: 'There has been an error occurring during the database query. For further assistance, please contact',
  dbh_login_account_creation_fail: 'New Account Creation Unsuccessful',
  dbh_login_account_creation_fail_tip: 'The creation of a new account has failed. For additional support, please reach out to',
  dbh_login_server_error_fail: 'Server Error',
  dbh_login_server_error_fail_tip: 'A server error has happened. To resolve this, we would appreciate your feedback. Please contact',
  dbh_login_google_network_fail: 'Network error',
  dbh_login_google_network_fail_tip: 'Please check the network and try again, if you have any question, please contact',
  dbh_login_choose_company_require: 'Please select a company',
  dbh_login_last_login: 'Last Login',
  dbh_login_agent_robot_tip: 'Hi! I am your exclusive game data AI agent.',
  dbh_login_agent_robot_tip_sub: "Ask me to check out today's game performance.",
  dbh_login_robot_hover: 'Click to go to DataBrain Agent',
  dbh_login_arrow_collapse: 'Click to collapse',
  dbh_login_arrow_expand: 'Click to expand',
};
